module.exports = __webpack_public_path__ + "img/computer.7b469724.svg";